class BrowserStorageUtil {
    setItem(key: string, value: unknown) {
        if (value) {
            window.localStorage.setItem(key, JSON.stringify(value));
        }
    }

    getItem(key: string) {
        const value = window.localStorage.getItem(key);
        if (value) {
            return JSON.parse(value);
        }
    }

    clearItems() {
        window.localStorage.clear();
    }
}

export default new BrowserStorageUtil();
